globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Account = appCustomerSpace.Modals.Account || {};

appCustomerSpace.Modals.Account.ContactTemporaryPassword = (function(superClass) {

  utils.extend(ContactTemporaryPassword, superClass);

  function ContactTemporaryPassword() {
    return ContactTemporaryPassword.__super__.constructor.apply(this, arguments);
  }

  $.extend(ContactTemporaryPassword.prototype, {
    init: function() {
      this._initEvents();

      return ContactTemporaryPassword.__super__.init.apply(this, arguments);
    },
    _initEvents: function(){
      var modal = this;

      $('.hide_modal_button').on('click', function(){
        utils.cookies.create('customer_space.account.hide_temporary_password_modal', true, 1);
        modal.close();
      });
    },
    open: function(){
      appCustomerSpace.Modules.PasswordComplexityMessages.init(this.$html);

      return ContactTemporaryPassword.__super__.open.apply(this, arguments);
    },
    callbackSuccess: function(data){
      var modal = this;

      if(!data.response) {
        appCustomerSpace.Loader().stop({$container: modal.$html.find('.modal-content')})
      } else {
        return ContactTemporaryPassword.__super__.callbackSuccess.apply(this, arguments);
      }
    },
  });

  return ContactTemporaryPassword;

})(appCustomerSpace.Modal);
